// Loume — Vorbestell-Abgleich im Warenkorb (27.09.2026)
//
// <lo-lieferung> steht an einer Warenkorb-Position, wenn sie laut Liquid als
// Vorbestellung gelten muss, aber noch keine Eigenschaft „Lieferung“ trägt
// (siehe snippets/loume-cart-extras.liquid, teil: 'lieferung'). Das Element
// setzt die Eigenschaft über /cart/change.js und lässt Dawn Drawer und
// Warenkorbseite neu zeichnen (cartUpdate). Danach trägt die Zeile die
// Eigenschaft, und Liquid rendert das Element nicht mehr.
//
// Die Kasse bleibt gesperrt, solange eine solche Position offen ist — sonst
// käme sie ohne Liefertermin dort an (Art. 246a EGBGB). Gesperrt werden die
// Kasse-Knöpfe in Drawer und Warenkorbseite und die Express-Knöpfe (PayPal,
// Shop Pay …) der Warenkorbseite. Die Sperre hängt am Zustand der Position,
// nicht am Element: Dawn zeichnet Positionen und Fuß getrennt neu, ein neuer
// Knopf wird also sofort wieder gesperrt, solange die Position offen ist.
//
// Schlägt die Anfrage fehl (Netz weg, 429 „Verifying your connection“ unter
// Last, 5xx), versucht das Skript es nach 1, 3 und 8 Sekunden erneut. Bleibt
// es dabei, erscheint an der Position der Hinweis aus den Theme-
// Einstellungen (loume_vorbestellung_fehler), und die Kasse bleibt gesperrt;
// ein Neuladen der Seite startet neu. Antwortet Shopify mit einem anderen
// Fehler (meist: die Zeile hat inzwischen einen anderen Schlüssel), wird neu
// gezeichnet und die neue Fassung versucht — höchstens zwei Durchläufe je
// Schlüssel.
//
// Eingebunden in cart-drawer.liquid und main-cart-items.liquid — auf der
// Warenkorbseite also zweimal. Deshalb in einer Funktion gekapselt und mit
// einem gemeinsamen Zustand am window: jede Zeile wird nur einmal zugleich
// versucht, auch wenn sie im Drawer und auf der Seite zugleich steht.
(() => {
  if (customElements.get('lo-lieferung')) return;

  const WARTEN = [0, 1000, 3000, 8000];
  const KASSE = '#CartDrawer-Checkout, #checkout';
  const EXPRESS = '.cart__dynamic-checkout-buttons';

  const zustand = (window.__loumeLieferung = window.__loumeLieferung || {
    status: new Map(), // Schlüssel → 'laeuft' | 'fertig' | 'fehler'
    runden: new Map(), // Schlüssel → Durchläufe
    anfragen: 0, // für die Messung
    kette: Promise.resolve(),
  });

  const wurzel = () => window.Shopify?.routes?.root || '/';
  const pause = (ms) => new Promise((fertig) => setTimeout(fertig, ms));
  const alle = () => Array.from(document.querySelectorAll('lo-lieferung'));
  const offen = (key) => ['laeuft', 'fehler'].includes(zustand.status.get(key));

  function sperreAktualisieren() {
    const sperren = alle().some((el) => offen(el.dataset.key));
    for (const knopf of document.querySelectorAll(KASSE)) {
      if (sperren && !knopf.hasAttribute('data-lo-sperre')) {
        knopf.setAttribute('data-lo-sperre', knopf.disabled ? 'war-aus' : '');
        knopf.disabled = true;
      } else if (!sperren && knopf.hasAttribute('data-lo-sperre')) {
        knopf.disabled = knopf.getAttribute('data-lo-sperre') === 'war-aus';
        knopf.removeAttribute('data-lo-sperre');
      }
    }
    for (const bereich of document.querySelectorAll(EXPRESS)) {
      if (sperren && !bereich.hasAttribute('data-lo-sperre')) {
        bereich.setAttribute('data-lo-sperre', '');
        bereich.inert = true;
        bereich.setAttribute('aria-disabled', 'true');
      } else if (!sperren && bereich.hasAttribute('data-lo-sperre')) {
        bereich.inert = false;
        bereich.removeAttribute('aria-disabled');
        bereich.removeAttribute('data-lo-sperre');
      }
    }
    for (const el of alle()) {
      const hinweis = el.querySelector('[data-lo-fehler]');
      if (hinweis) hinweis.hidden = zustand.status.get(el.dataset.key) !== 'fehler';
    }
  }

  // Nach dem Neuzeichnen noch einmal: Dawn ersetzt erst die Positionen, dann
  // den Fuß mit dem Kasse-Knopf — der neue Knopf kommt nach dem Element.
  const spaeterAktualisieren = () => {
    sperreAktualisieren();
    setTimeout(sperreAktualisieren, 0);
  };

  async function setzen(key) {
    zustand.runden.set(key, (zustand.runden.get(key) || 0) + 1);
    let ergebnis = 'fehler';
    let korb = null;

    for (const warten of WARTEN) {
      if (warten) await pause(warten);
      // Die jüngste Fassung der Zeile (Menge kann sich geändert haben). Ist
      // keine mehr da, braucht die Zeile keine Eigenschaft mehr.
      const el = alle().filter((e) => e.dataset.key === key).pop();
      if (!el) {
        ergebnis = 'weg';
        break;
      }
      let eigenschaften = {};
      try {
        const roh = JSON.parse(el.dataset.eigenschaften || '{}');
        if (roh && typeof roh === 'object' && !Array.isArray(roh)) eigenschaften = roh;
      } catch (e) {
        // leere Eigenschaften
      }
      eigenschaften.Lieferung = el.dataset.text;

      let antwort = null;
      try {
        zustand.anfragen += 1;
        antwort = await fetch(`${wurzel()}cart/change.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            id: key,
            quantity: parseInt(el.dataset.menge, 10) || 1,
            properties: eigenschaften,
          }),
        });
      } catch (e) {
        continue; // Netz weg: noch einmal
      }
      if (antwort.ok) {
        korb = await antwort.json().catch(() => null);
        ergebnis = 'fertig';
        break;
      }
      if (antwort.status === 429 || antwort.status >= 500) continue;
      ergebnis = 'veraltet';
      break;
    }

    if (ergebnis === 'fertig') zustand.status.set(key, 'fertig');
    else if (ergebnis === 'weg') zustand.status.delete(key);
    else if (ergebnis === 'veraltet' && zustand.runden.get(key) < 2) zustand.status.delete(key);
    else zustand.status.set(key, 'fehler');
    sperreAktualisieren();

    // Neu zeichnen: nach Erfolg zeigt die Zeile die Eigenschaft, nach einem
    // veralteten Schlüssel kommt die neue Fassung (und wird erneut versucht).
    if ((ergebnis === 'fertig' || ergebnis === 'veraltet') && typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      publish(PUB_SUB_EVENTS.cartUpdate, { source: 'loume-lieferung', cartData: korb });
    }
    document.dispatchEvent(new CustomEvent('loume:lieferung', { detail: { key, ergebnis } }));
  }

  class LoumeLieferung extends HTMLElement {
    connectedCallback() {
      const key = this.dataset.key;
      if (!key) return;
      if (!zustand.status.has(key)) {
        zustand.status.set(key, 'laeuft');
        // Immer nur eine Änderung zugleich: jede kann Zeilen zusammenlegen.
        zustand.kette = zustand.kette
          .then(() => setzen(key))
          .catch(() => {
            zustand.status.set(key, 'fehler');
            sperreAktualisieren();
          });
      }
      spaeterAktualisieren();
    }

    disconnectedCallback() {
      // Zeile entfernt oder neu gezeichnet: vielleicht ist nichts mehr offen.
      setTimeout(sperreAktualisieren, 0);
    }
  }

  customElements.define('lo-lieferung', LoumeLieferung);
})();
